var render = function () {
  var _vm$form;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "invoice-add-wrapper"
  }, [_c('b-row', {
    staticClass: "invoice-add"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "xl": "12",
      "md": "12"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('b-card', {
    staticClass: "invoice-preview-card",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "invoice-padding pb-0"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
  }, [_c('div', {
    staticClass: "invoice-number-date mt-md-0 mt-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('h4', {
    staticClass: "invoice-title mr-2"
  }, [_vm._v("Invoice")])]), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }), (_vm$form = _vm.form) !== null && _vm$form !== void 0 && _vm$form.invoice_number ? _c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('span', {
    staticClass: "title mr-2"
  }, [_vm._v(" Number: ")]), _c('span', [_vm._v(_vm._s(_vm.form.invoice_number))])]) : _vm._e(), _c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('span', {
    staticClass: "title mr-2"
  }, [_vm._v(" Date: ")]), _c('flat-pickr', {
    staticClass: "form-control invoice-edit-input",
    model: {
      value: _vm.form.issue_date,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "issue_date", $$v);
      },
      expression: "form.issue_date"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "title mr-2"
  }, [_vm._v(" Due Date: ")]), _c('flat-pickr', {
    staticClass: "form-control invoice-edit-input",
    model: {
      value: _vm.form.due_date,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "due_date", $$v);
      },
      expression: "form.due_date"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "title mr-2"
  }, [_vm._v("Currency:")]), _c('v-select', {
    staticClass: "form-control",
    staticStyle: {
      "border": "none",
      "margin-left": "31px"
    },
    attrs: {
      "id": "currency-id",
      "options": _vm.currenciesOption,
      "reduce": function reduce(option) {
        return option.name;
      },
      "label": "name",
      "placeholder": "Choose a currency"
    },
    model: {
      value: _vm.form.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "currency", $$v);
      },
      expression: "form.currency"
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-column mt-1"
  }, [_c('div', [_c('b-form-group', {
    attrs: {
      "label": "Company Logo"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.settings.invoice_logo_view.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.settings.invoice_logo_view, "enabled", $$v);
      },
      expression: "settings.invoice_logo_view.enabled"
    }
  }), _c('b-form-file', {
    attrs: {
      "accept": "image/*",
      "browse-text": "Choose Logo",
      "placeholder": "Upload logo",
      "disabled": !_vm.settings.invoice_logo_view.enabled
    },
    on: {
      "change": _vm.onLogoChange
    }
  })], 1), _vm.validationErrors.invoice_logo_view ? _c('small', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(_vm._s(_vm.validationErrors.invoice_logo_view))]) : _vm._e()])], 1), _vm.settings.invoice_logo_view.enabled && _vm.form.invoice_logo_view ? _c('div', {
    staticClass: "mt-2 text-center"
  }, [_c('img', {
    staticStyle: {
      "height": "60px",
      "max-width": "150px"
    },
    attrs: {
      "src": _vm.form.invoice_logo_view,
      "alt": "Logo Preview"
    }
  })]) : _vm._e()])]), _c('div', [_c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('h6', {
    staticClass: "mb-0"
  }, [_vm._v("From:")])]), _c('b-card', [_c('b-form-group', {
    attrs: {
      "label": "Company Name"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.settings.company_name.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.settings.company_name, "enabled", $$v);
      },
      expression: "settings.company_name.enabled"
    }
  }), _c('b-form-input', {
    attrs: {
      "disabled": !_vm.settings.company_name.enabled
    },
    model: {
      value: _vm.form.company_name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "company_name", $$v);
      },
      expression: "form.company_name"
    }
  })], 1), _vm.validationErrors.company_name ? _c('small', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(_vm._s(_vm.validationErrors.company_name))]) : _vm._e()]), _c('b-form-group', {
    attrs: {
      "label": "Company Email"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.settings.company_email.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.settings.company_email, "enabled", $$v);
      },
      expression: "settings.company_email.enabled"
    }
  }), _c('b-form-input', {
    attrs: {
      "type": "email",
      "disabled": !_vm.settings.company_email.enabled
    },
    model: {
      value: _vm.form.company_email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "company_email", $$v);
      },
      expression: "form.company_email"
    }
  })], 1), _vm.validationErrors.company_email ? _c('small', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(_vm._s(_vm.validationErrors.company_email))]) : _vm._e()]), _c('b-form-group', {
    attrs: {
      "label": "Company Phone"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.settings.company_phone.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.settings.company_phone, "enabled", $$v);
      },
      expression: "settings.company_phone.enabled"
    }
  }), _c('b-form-input', {
    attrs: {
      "disabled": !_vm.settings.company_phone.enabled
    },
    model: {
      value: _vm.form.company_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "company_phone", $$v);
      },
      expression: "form.company_phone"
    }
  })], 1), _vm.validationErrors.company_phone ? _c('small', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(_vm._s(_vm.validationErrors.company_phone))]) : _vm._e()]), _c('b-form-group', {
    attrs: {
      "label": "Company Address"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.settings.company_address.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.settings.company_address, "enabled", $$v);
      },
      expression: "settings.company_address.enabled"
    }
  }), _c('b-form-textarea', {
    attrs: {
      "rows": "2",
      "disabled": !_vm.settings.company_address.enabled
    },
    model: {
      value: _vm.form.company_address,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "company_address", $$v);
      },
      expression: "form.company_address"
    }
  })], 1), _vm.validationErrors.company_address ? _c('small', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(_vm._s(_vm.validationErrors.company_address))]) : _vm._e()])], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
  }, [_c('div', [_c('div', {
    staticClass: "d-flex align-items-center mb-1"
  }, [_c('h6', {
    staticClass: "mb-0"
  }, [_vm._v("Bill To:")])]), _c('b-card', [_c('b-form-group', {
    attrs: {
      "label": "Customer Name"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.settings.customer_name.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.settings.customer_name, "enabled", $$v);
      },
      expression: "settings.customer_name.enabled"
    }
  }), _c('b-form-input', {
    attrs: {
      "disabled": !_vm.settings.customer_name.enabled
    },
    model: {
      value: _vm.form.customer_name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customer_name", $$v);
      },
      expression: "form.customer_name"
    }
  })], 1), _vm.validationErrors.customer_name ? _c('small', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(_vm._s(_vm.validationErrors.customer_name))]) : _vm._e()]), _c('b-form-group', {
    attrs: {
      "label": "Customer Email"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.settings.customer_email.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.settings.customer_email, "enabled", $$v);
      },
      expression: "settings.customer_email.enabled"
    }
  }), _c('b-form-input', {
    attrs: {
      "type": "email",
      "disabled": !_vm.settings.customer_email.enabled
    },
    model: {
      value: _vm.form.customer_email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customer_email", $$v);
      },
      expression: "form.customer_email"
    }
  })], 1), _vm.validationErrors.customer_email ? _c('small', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(_vm._s(_vm.validationErrors.customer_email))]) : _vm._e()]), _c('b-form-group', {
    attrs: {
      "label": "Customer Phone"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.settings.customer_phone.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.settings.customer_phone, "enabled", $$v);
      },
      expression: "settings.customer_phone.enabled"
    }
  }), _c('b-form-input', {
    attrs: {
      "disabled": !_vm.settings.customer_phone.enabled
    },
    model: {
      value: _vm.form.customer_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customer_phone", $$v);
      },
      expression: "form.customer_phone"
    }
  })], 1), _vm.validationErrors.customer_phone ? _c('small', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(_vm._s(_vm.validationErrors.customer_phone))]) : _vm._e()]), _c('b-form-group', {
    attrs: {
      "label": "Customer Address"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.settings.customer_address.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.settings.customer_address, "enabled", $$v);
      },
      expression: "settings.customer_address.enabled"
    }
  }), _c('b-form-textarea', {
    attrs: {
      "rows": "2",
      "disabled": !_vm.settings.customer_address.enabled
    },
    model: {
      value: _vm.form.customer_address,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customer_address", $$v);
      },
      expression: "form.customer_address"
    }
  })], 1), _vm.validationErrors.customer_address ? _c('small', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(_vm._s(_vm.validationErrors.customer_address))]) : _vm._e()])], 1)], 1)])])]), _c('b-card-body', {
    staticClass: "invoice-padding pt-0"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('h6', {
    staticClass: "mb-0"
  }, [_vm._v("Items")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": _vm.addNewItem
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _c('span', [_vm._v("Add Item")])], 1)], 1), _c('b-table', {
    staticClass: "invoice-item-table",
    attrs: {
      "responsive": "",
      "items": _vm.form.items,
      "fields": _vm.itemFields,
      "tbody-tr-class": _vm.rowClass
    },
    scopedSlots: _vm._u([{
      key: "cell(index)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.index + 1) + " ")];
      }
    }, {
      key: "cell(item_name)",
      fn: function fn(data) {
        return [_c('b-form-input', {
          attrs: {
            "size": "sm",
            "placeholder": "Item Name",
            "required": "",
            "state": data.item.item_name ? true : false
          },
          model: {
            value: data.item.item_name,
            callback: function callback($$v) {
              _vm.$set(data.item, "item_name", $$v);
            },
            expression: "data.item.item_name"
          }
        })];
      }
    }, {
      key: "cell(item_description)",
      fn: function fn(data) {
        return [_c('b-form-input', {
          attrs: {
            "size": "sm",
            "placeholder": "Item Description",
            "state": data.item.item_description ? true : false
          },
          model: {
            value: data.item.item_description,
            callback: function callback($$v) {
              _vm.$set(data.item, "item_description", $$v);
            },
            expression: "data.item.item_description"
          }
        })];
      }
    }, {
      key: "cell(quantity)",
      fn: function fn(data) {
        return [_c('b-form-input', {
          attrs: {
            "type": "number",
            "min": "1",
            "size": "sm",
            "state": data.item.quantity > 0 ? true : false
          },
          on: {
            "input": function input($event) {
              return _vm.calculateItemTotal(data.item);
            }
          },
          model: {
            value: data.item.quantity,
            callback: function callback($$v) {
              _vm.$set(data.item, "quantity", _vm._n($$v));
            },
            expression: "data.item.quantity"
          }
        })];
      }
    }, {
      key: "cell(unit_price)",
      fn: function fn(data) {
        return [_c('b-form-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "step": "0.01",
            "size": "sm",
            "state": data.item.unit_price >= 0 ? true : false
          },
          on: {
            "input": function input($event) {
              return _vm.calculateItemTotal(data.item);
            }
          },
          model: {
            value: data.item.unit_price,
            callback: function callback($$v) {
              _vm.$set(data.item, "unit_price", _vm._n($$v));
            },
            expression: "data.item.unit_price"
          }
        })];
      }
    }, {
      key: "cell(total)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.total) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-danger",
            "size": "sm",
            "b-tooltip.hover": "form.items.length <= 1 ? 'At least one item is required' : 'Remove item'"
          },
          on: {
            "click": function click($event) {
              return _vm.removeItem(data.index);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        })], 1)];
      }
    }])
  })], 1), _c('b-card-body', {
    staticClass: "invoice-padding invoice-summary"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "table table-borderless w-100"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between py-1 border-bottom"
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Subtotal:")]), _c('div', [_vm._v(_vm._s(_vm.subtotal))])]), _c('div', {
    staticClass: "d-flex justify-content-between py-1 border-bottom align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.discount.enabled,
      expression: "settings.discount.enabled"
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.discount.enabled) ? _vm._i(_vm.settings.discount.enabled, null) > -1 : _vm.settings.discount.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.discount.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.discount, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.discount, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.discount, "enabled", $$c);
        }
      }
    }
  }), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Discount:")])]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', [_c('b-form-input', {
    staticClass: "mr-1",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "size": "sm",
      "disabled": !_vm.settings.discount.enabled
    },
    on: {
      "input": _vm.calculateTotals
    },
    model: {
      value: _vm.form.discount,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "discount", _vm._n($$v));
      },
      expression: "form.discount"
    }
  }), _vm.validationErrors.discount ? _c('div', {
    staticClass: "text-danger font-weight-bold mt-1"
  }, [_vm._v(" " + _vm._s(_vm.validationErrors.discount) + " ")]) : _vm._e()], 1), _c('span', [_vm._v(_vm._s(_vm.form.discount))])])]), _c('div', {
    staticClass: "d-flex justify-content-between py-1 border-bottom align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.tax.enabled,
      expression: "settings.tax.enabled"
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.tax.enabled) ? _vm._i(_vm.settings.tax.enabled, null) > -1 : _vm.settings.tax.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.tax.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.tax, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.tax, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.tax, "enabled", $$c);
        }
      }
    }
  }), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Tax (%):")])]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', [_c('b-form-input', {
    staticClass: "mr-1",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "size": "sm",
      "disabled": !_vm.settings.tax.enabled
    },
    on: {
      "input": _vm.calculateTaxAmount
    },
    model: {
      value: _vm.form.tax,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tax", _vm._n($$v));
      },
      expression: "form.tax"
    }
  }), _vm.validationErrors.tax ? _c('div', {
    staticClass: "text-danger font-weight-bold mt-1"
  }, [_vm._v(" " + _vm._s(_vm.validationErrors.tax) + " ")]) : _vm._e()], 1), _c('span', [_vm._v(_vm._s(_vm.taxAmount))])])]), _c('div', {
    staticClass: "d-flex justify-content-between py-1 border-bottom align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.vat.enabled,
      expression: "settings.vat.enabled"
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.vat.enabled) ? _vm._i(_vm.settings.vat.enabled, null) > -1 : _vm.settings.vat.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.vat.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.vat, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.vat, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.vat, "enabled", $$c);
        }
      }
    }
  }), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("VAT (%):")])]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', [_c('b-form-input', {
    staticClass: "mr-1",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "size": "sm",
      "disabled": !_vm.settings.vat.enabled
    },
    on: {
      "input": _vm.calculateVatAmount
    },
    model: {
      value: _vm.form.vat,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vat", _vm._n($$v));
      },
      expression: "form.vat"
    }
  }), _vm.validationErrors.vat ? _c('div', {
    staticClass: "text-danger font-weight-bold mt-1"
  }, [_vm._v(" " + _vm._s(_vm.validationErrors.vat) + " ")]) : _vm._e()], 1), _c('span', [_vm._v(_vm._s(_vm.vatAmount))])])]), _c('div', {
    staticClass: "d-flex justify-content-between py-1 border-bottom align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.due_amount.enabled,
      expression: "settings.due_amount.enabled"
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.due_amount.enabled) ? _vm._i(_vm.settings.due_amount.enabled, null) > -1 : _vm.settings.due_amount.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.due_amount.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.due_amount, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.due_amount, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.due_amount, "enabled", $$c);
        }
      }
    }
  }), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Due Amount:")])]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', [_c('b-form-input', {
    staticClass: "mr-1",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "size": "sm",
      "disabled": !_vm.settings.due_amount.enabled
    },
    on: {
      "input": _vm.calculateDueAmount
    },
    model: {
      value: _vm.form.due_amount,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "due_amount", _vm._n($$v));
      },
      expression: "form.due_amount"
    }
  }), _vm.validationErrors.due_amount ? _c('div', {
    staticClass: "text-danger font-weight-bold mt-1"
  }, [_vm._v(" " + _vm._s(_vm.validationErrors.due_amount) + " ")]) : _vm._e()], 1), _c('span', [_vm._v(_vm._s(_vm.form.due_amount))])])]), _c('div', {
    staticClass: "d-flex justify-content-between py-2 border-top"
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Total:")]), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.form.total) + " ")])])])])], 1), _c('b-row', [_c('b-col', {
    staticClass: "mb-md-0 mb-3 mt-2",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.notes.enabled,
      expression: "settings.notes.enabled"
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.notes.enabled) ? _vm._i(_vm.settings.notes.enabled, null) > -1 : _vm.settings.notes.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.notes.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.notes, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.notes, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.notes, "enabled", $$c);
        }
      }
    }
  }), _c('h6', {
    staticClass: "mb-0"
  }, [_vm._v("Additional Notes")])]), _c('b-form-textarea', {
    attrs: {
      "disabled": !_vm.settings.notes.enabled,
      "rows": "3",
      "placeholder": "Notes..."
    },
    model: {
      value: _vm.form.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "notes", $$v);
      },
      expression: "form.notes"
    }
  }), _vm.settings.notes.enabled && _vm.validationErrors.notes ? _c('div', {
    staticClass: "text-danger font-weight-bold mt-1"
  }, [_vm._v(" " + _vm._s(_vm.validationErrors.notes) + " ")]) : _vm._e()], 1)], 1), _vm.isEditMode ? [_c('div', {
    staticClass: "d-flex align-items-center mb-2 mt-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.isPaid,
      expression: "isPaid"
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPaid) ? _vm._i(_vm.isPaid, null) > -1 : _vm.isPaid
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.isPaid,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPaid = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.isPaid = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.isPaid = $$c;
        }
      }
    }
  }), _c('h6', {
    staticClass: "mb-0"
  }, [_vm._v("Is Payment Done")])])] : _vm._e()], 2), _c('b-card-body', {
    staticClass: "invoice-padding"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between mt-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" Cancel ")]), _c('div', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.submitInvoice
    }
  }, [_vm.loading ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isEditMode ? "Update Invoice" : "Create Invoice") + " ")], 1)], 1)], 1)])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }